import React, { useState } from 'react';
import { styled } from '@mui/material';
import { OutlinedDropdown, OutlinedTextInput, PrimaryButton, SizeableRoundedDialog, Text } from 'library';
import { client, consoleLogInDev } from 'shared';

const ReasonOptions = [
    'Worker arrived late',
    'Worker was not fully compliant',
    'Worker was not in dress code',
    'Other (please explain)',
];

export function SentHomeDisputeModal({
    small,
    isOpen,
    onClose,
    onSubmit,
    appointmentId,
    workerName,
}: {
    small: boolean;
    isOpen: boolean;
    onClose: () => void;
    onSubmit: () => void;
    appointmentId?: number;
    workerName: string;
}) {
    const [reason, setReason] = useState('');
    const [comment, setComment] = useState('');

    function onDisputeClick() {
        const details = comment ? `${reason}: ${comment}` : reason;
        client('api/disputes/', { body: { details, object_id: appointmentId, dispute_type: 'appointment' } })
            .then(() => {
                setReason('');
                setComment('');
                onSubmit();
            })
            .catch((error) => {
                consoleLogInDev(error);
            });
    }

    return (
        <SizeableRoundedDialog
            open={isOpen}
            onClose={onClose}
            fullScreen={false}
            contentStyle={{ padding: 0 }}
            style={{ width: small ? '100%' : '40%' }}
            closeButton
        >
            <Inner>
                <Text variant="h1">Why are you disputing that {workerName} was sent home?</Text>
                <Text variant="caption">Please answer below</Text>
                <Row>
                    <OutlinedDropdown
                        textLabel="Select a reason"
                        value={reason || ''}
                        fields={
                            ReasonOptions.map((b) => {
                                return { key: b, value: b };
                            }) || []
                        }
                        onChange={(e) => setReason(e.target.value)}
                    />
                </Row>
                <Row>
                    <OutlinedTextInput
                        label="Comments"
                        value={comment}
                        multiline={true}
                        rows={2}
                        onChange={(e) => setComment(e.target.value)}
                        style={{ width: '100%' }}
                    />
                </Row>
                <Row>
                    <PrimaryButton
                        onClick={onDisputeClick}
                        disabled={!reason || (reason === ReasonOptions[3] && !comment)}
                        buttonStyle={{ width: 'fit-content', alignSelf: 'flex-end' }}
                    >
                        Submit Dispute
                    </PrimaryButton>
                </Row>
            </Inner>
        </SizeableRoundedDialog>
    );
}

const Inner = styled('div')({
    padding: 20,
});

const Row = styled('div')({
    alignItems: 'center',
    display: 'flex',
    marginTop: 15,
    width: '100%',
});
